import { type ComputedRef, type MaybeRef, computed, reactive, unref } from "vue";

import type { Permission } from "@/services/PermissionsService";

export type MenuItem = {
    label: string;
    icon?: string;
    to?: string;
    separator?: boolean;
    items?: MenuItem[];
    permission?: Permission | Permission[];
};

type LayoutConfig = {
    menuMode: "drawer";
};

type LayoutState = {
    staticMenuDesktopInactive: boolean;
    overlayMenuActive: boolean;
    configSidebarVisible: boolean;
    menuHoverActive: boolean;
    topbarMenuActive: boolean;
    sidebarActive: boolean;
    anchored: boolean;
    activeMenuItem: string | null;
    overlaySubmenuActive: boolean;
};

type UseLayout = {
    layoutConfig: LayoutConfig;
    layoutState: LayoutState;
    isSidebarActive: ComputedRef<boolean>;
    setActiveMenuItem: (item: MaybeRef<string | null>) => void;
};

const layoutConfig = reactive<LayoutConfig>({
    menuMode: "drawer",
});

const layoutState = reactive<LayoutState>({
    staticMenuDesktopInactive: false,
    overlayMenuActive: false,
    configSidebarVisible: false,
    menuHoverActive: false,
    topbarMenuActive: false,
    sidebarActive: localStorage.getItem("sidebarAnchored") === "true",
    anchored: localStorage.getItem("sidebarAnchored") === "true",
    activeMenuItem: null,
    overlaySubmenuActive: false,
});

export function useLayout(): UseLayout {
    function setActiveMenuItem(item: MaybeRef<string | null>): void {
        layoutState.activeMenuItem = unref(item);
    }

    const isSidebarActive = computed(() => layoutState.overlayMenuActive || layoutState.overlaySubmenuActive);

    return {
        layoutConfig,
        layoutState,
        isSidebarActive,
        setActiveMenuItem,
    };
}
